var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructionSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 1.66667H2.5C2.03704 1.66667 1.66667 2.03704 1.66667 2.5V17.5C1.66667 17.8704 2.03704 18.3333 2.5 18.3333H17.5C17.8704 18.3333 18.3333 17.8704 18.3333 17.5V2.5C18.3333 2.03704 17.8704 1.66667 17.5 1.66667ZM7.22295 5.37109H5.37109V7.22295H7.22295V5.37109ZM14.6294 5.37109H9.07389V7.22295H14.6294V5.37109ZM14.6294 9.07389H9.07389V10.9257H14.6294V9.07389ZM9.07389 12.7775H14.6294V14.6294H9.07389V12.7775ZM5.37109 9.07389H7.22295V10.9257H5.37109V9.07389ZM7.22295 12.7775H5.37109V14.6294H7.22295V12.7775ZM3.51807 16.481H16.481V3.51807H3.51807V16.481Z",
    fill: "#929F9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionSm);
export default __webpack_public_path__ + "static/media/instruction-sm.9288c5a8.svg";
export { ForwardRef as ReactComponent };